<template>
  <div class="user-list-combox">
    <el-table :data="pageData.items" style="width: 100%" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" />
      <el-table-column prop="account_id" label="ID" width="100" />
      <el-table-column label="头像" width="60">
        <template slot-scope="scope">
          <img class="avatar" v-if="scope.row.user.avatar" :src="scope.row.user.avatar" :alt="scope.row.user.nickname" />
        </template>
      </el-table-column>
      <el-table-column label="昵称">
        <template slot-scope="scope">
          {{scope.row.user.nickname}}
        </template>
      </el-table-column>
      <el-table-column label="性别">
        <template slot-scope="scope">
          {{scope.row.gender === '2' ? '女' : '男'}}
        </template>
      </el-table-column>
      <el-table-column label="审核状态">
        <template slot-scope="scope">
          {{userConfig.auditStatusMap[scope.row.status]['title']}}
        </template>
      </el-table-column>
      <el-table-column prop="ctime" label="时间" width="300" />
      <el-table-column header-align="center" label="操作" width="160">
        <template slot-scope="scope">
          <span class="action" v-for="(action,index) in scope.row.actions" :key="'action-' +index" @click="processAction(action.remark, scope.row)">{{action['title']}}</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination" v-if="pageData.totalPage">
      <el-pagination background layout="total, prev, pager, next" :total="pageData.amount" :page-size="pageData.pageSize" @current-change="handlePageChange" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserListComponent',
  props: {
    pageData: {}
  },
  data () {
    return {
      ids: []
    }
  },
  methods: {
    handleSelectionChange (val) {
      let ids = []
      for (let i in val) {
        ids.push(val[i]['id'])
      }
      this.$emit('onSelectChanged', ids)
    },
    processAction (action, data) {
      switch (action) {
        case 'VIEW':
          return this.$emit('view', data)
        case 'PASS':
          return this.$emit('pass', data)
        case 'REFUSE':
          return this.$emit('refuse', data)
        default:
          this.$message.error('未知的操作类型')
      }
    },
    handlePageChange (val) {
      this.$emit('onPageChanged', val)
    }
  }
}
</script>

<style scoped lang="less">
.pagination {
  margin-top: 20px;
  text-align: center;
}

.action {
  color: #3a8ee6;
  padding: 0 5px;

  &:hover {
    cursor: pointer;
  }
}

.avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/user/MilkUserListComponent.vue